import type { SubCustomersTranslations } from './types'

export const enTranslations: SubCustomersTranslations = {
  title: 'Customers',
  subtitle: 'Manage your customers',
  addCustomer: 'Add Customer',
  editCustomer: 'Edit Customer',
  deleteCustomer: 'Delete Customer',
  customerCode: 'Code',
  customerName: 'Name',
  customerPhone: 'Phone',
  selectCustomer: 'Select Customer',
  changeCustomer: 'Change Customer',
  noCustomer: 'No customer assigned',
  addNewCustomer: 'Add New Customer',
  createNewCustomer: 'Create New Customer',
  hideCreate: 'Hide',
  namePlaceholder: 'Enter customer name',
  phonePlaceholder: 'Enter phone number (optional)',
  searchPlaceholder: 'Search customers...',
  noCustomersFound: 'No customers found',
  deleteConfirmTitle: 'Delete Customer',
  deleteConfirmDescription: 'Are you sure you want to delete this customer?',
  saveSuccess: 'Customer saved successfully',
  saveError: 'Failed to save customer',
  deleteSuccess: 'Customer deleted successfully',
  deleteError: 'Failed to delete customer',
  customerType: 'Type',
  typeRegular: 'Regular',
  typePlaceholder: 'Unknown customer',
  typePlaceholderHint: 'Placeholder for when the real customer is not known yet. Replace it on the order after delivery.',
  placeholderOnOrderHint: 'Unknown customer — replace with the real customer after delivery',
  selectTenantToAdd: 'Select a customer in the header to add sub-customers',
  typeAll: 'All',
  mainCustomer: 'Main customer',
  total: 'Total',
  noCustomersFoundHint: 'Try another search or type',
  loadError: 'Could not load customers',
  searching: 'Searching…',
  remove: 'Remove',
}
